/**
 * Validator for EndTurn action.
 *
 * Rules (§6.2, §11.1, §14):
 *   1. stateVersion matches.
 *   2. Phase is "endTurn".
 *
 * Per the spec: EndTurn is valid whenever the phase is "endTurn". The engine
 * guarantees that phase "endTurn" is only reached after all prior obligations
 * are met (wildlife placed or returned, landmark choice resolved if applicable).
 * The validator trusts the phase as the authoritative gate.
 */

import type { EndTurnAction } from "../types/actions";
import type { ValidationResult } from "../types/common";
import type { GameState } from "../types/game-state";
import { commonGuards, VALID } from "./common-guards";

export const validateEndTurn = (
  state: GameState,
  action: EndTurnAction,
): ValidationResult => {
  const guard = commonGuards(state, action.stateVersion, "endTurn");
  if (guard !== null) {
    return guard;
  }

  return VALID;
};
